import React, { useEffect, useState } from "react";
import { Menu, Button, MenuProps, Input, Modal, Tabs, Select, message, notification, Row, Col } from 'antd';
import { v4 as uuidv4 } from 'uuid';
import { useNavigate } from "react-router-dom";


import Header from '../common/header'
import noStrategy from '../common/img/noStrategy.png'
import fetchLogs from "../common/helpers/fetch-logs";
import moment from "moment";

const { Option } = Select;
const { TabPane } = Tabs;


const tableHeaderStyle = { fontSize: 16, borderTop: "1px solid #cccccc", borderBottom: "1px solid #cccccc", color: "white", textAlign: "left" }
const tableRowStyle = { fontSize: 16, borderTop: "1px solid #cccccc", borderBottom: "1px solid #cccccc", color: "white", textAlign: "left", padding: 5 }
const tableRowEditStyle = { borderTop: "1px solid #cccccc", borderBottom: "1px solid #cccccc", paddingRight: 10 }

const History = ({ selectedBot, setDisplayHistorySection }) => {
    // let navigate = useNavigate();

    const [orders, setOrders] = useState([]);
    const [rebalanceOrders, setRebalanceOrders] = useState([]);

    useEffect(() => {
        fetchLogs(selectedBot.id).then(res => {
            if (res) {
                let newOrders = [];
                let newRebalanceOrders = [];
                res.forEach(order => {
                    // const parsed = JSON.parse(order.log)
                    const parsed = order.log
                    if (parsed.log_type === 'order') {
                        newOrders.push(parsed.data);
                    } else if (parsed.log_type === 'rebalance') {
                        newRebalanceOrders.push(parsed.data);
                    }
                })
                console.log({ newOrders })
                console.log({
                    newRebalanceOrders
                })
                setOrders(newOrders);
                setRebalanceOrders(newRebalanceOrders);
            }
        })
    }, [])
    return (
        <>

            <div style={{ height: "90%" }}>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", padding: 15 }}>
                    <div onClick={() => { setDisplayHistorySection(false); }} style={{ display: "flex", cursor: "pointer", flexDirection: "row", gap: 10 }}>
                        <div style={{ color: "grey", fontSize: 17, textDecoration: "underline" }}>My bot list {'>'} Advanced {'>'} </div>
                        <div style={{ position: "relative", top: 3 }}>
                            <div style={{ color: "white" }}>{selectedBot.name} {'>'} History</div>
                            <div style={{ fontSize: 13, color: "grey" }} >{selectedBot.description || '-'}</div>
                        </div>

                    </div>
                    <div style={{ display: "flex", flexDirection: "row", gap: 10 }}>
                        {/* <Button style={{ backgroundColor: "#161616", color: "white", width: 120, height: 50 }} type="default">REBALANCE</Button> */}
                        {/* <Button onClick={() => { navigate('/balance') }} style={{ backgroundColor: "#161616", color: "white", width: 120, height: 50 }} type="default">BALANCE</Button>
                        <Button style={{ backgroundColor: "#161616", color: "white", width: 120, height: 50 }} type="default">HISTORY</Button>
                        <Button style={{ backgroundColor: "#161616", color: "white", width: 180, height: 50 }} type="default">CONFIGURE ALERTS</Button> */}
                    </div>
                </div>
                <hr style={{ width: "99%", backgroundColor: "white", textAlign: "center" }} />

                <Tabs defaultActiveKey="1" style={{ color: "white", marginLeft: 10 }} >
                    <TabPane tab="STRATEGY HISTORY" style={{ height: "70%", color: "white" }} key="1">
                        <div style={{ display: "flex", flexDirection: "row", width: "100%", padding: 10 }}>
                            <div style={{ display: "flex", flexDirection: "column", borderRadius: 5, width: "100%" }}>
                                <div style={{ overflowY: "auto", overflowX: "hidden" }}>
                                    <table style={{ width: "100%", }}>
                                        <tr>
                                            {/* <th style={tableHeaderStyle} >COUNTER TRADE (OFFER)</th> */}
                                            <th style={tableHeaderStyle} >REBALANCE PROFILE (PLATFORM)</th>
                                            <th style={tableHeaderStyle} >REBALANCE (SYMBOL)</th>
                                            <th style={tableHeaderStyle} >SIDE</th>
                                            <th style={tableHeaderStyle} >PRICE</th>
                                            <th style={tableHeaderStyle} >AMOUNT/SIZE</th>
                                            <th style={tableHeaderStyle} >TIME OF TRADE</th>
                                        </tr>
                                        {orders.slice().reverse().map(order => {
                                            return <tr>
                                                <td style={tableRowStyle}>{order.rebalance_name || '--'}</td>
                                                <td style={tableRowStyle}>{order.rebalance_symbol || '--'}</td>
                                                <td style={tableRowStyle}>{order.side || '--'}</td>
                                                <td style={tableRowStyle}>{order.order_price || '--'}</td>
                                                <td style={tableRowStyle}>{order.size || '--'}</td>
                                                <td style={tableRowStyle}>{moment(order.created_at).format('MMMM Do YYYY h:mm:ss a') || '-'}</td>
                                            </tr>
                                        })}



                                        {/* <tr>
                                    <td style={tableRowStyle}>
                                        <div>Bot Binance buy side <span style={{ textDecoration: "underline", cursor: "pointer" }}>(EDIT)</span> </div>
                                        <div style={{ fontSize: 13, color: "grey" }} >buy side bot tight spread 0.2-0.3%</div>
                                    </td>
                                    <td style={tableRowStyle}>
                                        Home XHT market making (HollaEx Pro)
                                    </td>
                                    <td style={tableRowStyle}>INACTIVE <span style={{ textDecoration: "underline", cursor: "pointer" }}>(EDIT)</span></td>
                                    <td style={tableRowStyle}><span style={{ textDecoration: "underline", cursor: "pointer" }}>(DELETE)</span></td>
                                </tr> */}
                                    </table>


                                </div>

                            </div>
                        </div>
                    </TabPane>
                    <TabPane tab="REBALANCE HISTORY" style={{ height: "70%" }} key="2">
                        <div style={{ display: "flex", flexDirection: "row", width: "100%", padding: 10 }}>
                            <div style={{ display: "flex", flexDirection: "column", borderRadius: 5, width: "100%" }}>
                                <div style={{ overflowY: "auto", overflowX: "hidden" }}>
                                    <table style={{ width: "100%", }}>
                                        <tr>
                                            <th style={tableHeaderStyle} >SYMBOL</th>
                                            <th style={tableHeaderStyle} >SIDE</th>
                                            <th style={tableHeaderStyle} >PRICE</th>
                                            <th style={tableHeaderStyle} >AMOUNT/SIZE</th>
                                            <th style={tableHeaderStyle} >TIME OF TRADE</th>
                                        </tr>
                                        {rebalanceOrders.slice().reverse().map(order => {
                                            return <tr>
                                                <td style={tableRowStyle}>{order.symbol || '--'}</td>
                                                <td style={tableRowStyle}>{order.side || '--'}</td>
                                                <td style={tableRowStyle}>{order.price || '--'}</td>
                                                <td style={tableRowStyle}>{order.amount || '--'}</td>
                                                <td style={tableRowStyle}>{moment(order.datetime).format('MMMM Do YYYY h:mm:ss a') || '-'}</td>
                                            </tr>
                                        })}


                                        {/* <tr>
                                    <td style={tableRowStyle}>
                                        <div>Bot Binance buy side <span style={{ textDecoration: "underline", cursor: "pointer" }}>(EDIT)</span> </div>
                                        <div style={{ fontSize: 13, color: "grey" }} >buy side bot tight spread 0.2-0.3%</div>
                                    </td>
                                    <td style={tableRowStyle}>
                                        Home XHT market making (HollaEx Pro)
                                    </td>
                                    <td style={tableRowStyle}>INACTIVE <span style={{ textDecoration: "underline", cursor: "pointer" }}>(EDIT)</span></td>
                                    <td style={tableRowStyle}><span style={{ textDecoration: "underline", cursor: "pointer" }}>(DELETE)</span></td>
                                </tr> */}
                                    </table>


                                </div>

                            </div>
                        </div>
                    </TabPane>

                </Tabs>

            </div>
            <div>
            </div>
        </>
    );
};

export default History;